import { render, staticRenderFns } from "./ServicePlans.vue?vue&type=template&id=0f91b42a&scoped=true"
import script from "./ServicePlans.vue?vue&type=script&lang=js"
export * from "./ServicePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f91b42a",
  null
  
)

export default component.exports